import React from "react";
import styles from "./template.module.scss";
import CertifiedIcon from "../../../assets/svgs/certified-icon.svg";

const Certificate = ({ PreviewCertificate }) => {
  return (
    <div
      id={styles["Preview-receipient-certificate"]}
      style={{ marginBottom: "2rem" }}
    >
      <div className={styles["certficate-container"]}>
        {PreviewCertificate?.thumbnail && (
          <figure>
            <img
              style={{
                width: "100%",
                height: "100%"
              }}
              src={`data:image/jpeg;base64,${PreviewCertificate.thumbnail}`}
              alt="certified-icon"
            />
          </figure>
        )}
        <div className={styles["certified-by"]}>
          <p>Certified by: </p>
          <span>
            <p>HNG Internship</p>
            <img src={CertifiedIcon} alt="certified-icon" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Certificate;
